import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        audio: {
            element: null,
            muted: false,
            isPlaying: false
        }
    },
    mutations: {
        setAudioElement(state, value) {
            state.audio.element = value;
        },
        setAudioPlaying(state, value) {
            state.audio.isPlaying = value;
        },
        turnAudio(state, value) {
            if (value === 'on') {
                if (state.audio.isPlaying === false && state.audio.element !== null) {
                    state.audio.element.play();
                }

                state.audio.element.muted = false;
                state.audio.isPlaying = true;
            } else {
                state.audio.element.muted = true;
                state.audio.isPlaying = false;
            }
        },
        muteAudio(state, value) {
            if (value) {
                state.audio.element.muted = value;
            } else {
                if (state.audio.isPlaying) {
                    state.audio.element.muted = value;
                }
            }
        }
    },
    actions: {
        setAudioElement({commit}, value) {
            commit('setAudioElement', value);
        },
        setAudioPlaying({commit}, value) {
            commit('setAudioPlaying', value);
        },
        turnAudio({commit}, value) {
            commit('turnAudio', value);
        },
        muteAudio({commit}, value) {
            commit('muteAudio', value);
        }
    }
});
